import React, { Component, Fragment } from 'react'
import { withStyles } from '@material-ui/core/styles'

// COMPONENTS
import Typography from '@material-ui/core/Typography'
import LeftNavigationDashboard from '../components/app-navigation/LeftNavigationDashboard'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../components/app-logo/logo-data'
import TraficLight from '../components/traficLight'
import CustomizeAll from '../components/сustomize-all/'

// import CrmApplication from '../components/crm-application/'
import Slide from '@material-ui/core/Slide'
import Dialog from '@material-ui/core/Dialog'
import ChatApplicationForm from '../components/app-form/ChatApplicationForm'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import Wrapper from '../components/wrapper'
import LicenseExpired from '../components/payment/LicenseExpired'
import { ActionsForUsing } from '../components/payment/LicenseExpired'

function Transition(props) {
  return <Slide direction="left" {...props} />
}

const styles = theme => ({
  pageTemplate: {
    maxWidth: 1072,
    margin: '0 auto',
  },
  wizardRow: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    marginBottom: 32,
  },
  wizardContent: {
    maxWidth: 940,
    width: '100%',
  },
  crmsList: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
  header: {
    padding: '15px 40px 6px 22px',
  },
  content: {
    padding: '16px 40px 30px 22px',
  },
  viewList: {
    margin: 0,
    padding: 0,
  },

  list: {
    padding: 0,
    listStyleType: 'none',
  },
  item: {
    marginBottom: 12,
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(136, 102, 255)',
    '&:hover': {
      textDecoration: 'none',
    },
  },
  icon: {
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 16px 32px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: 'rgb(255, 204, 0)',
    borderRadius: '100%',
    marginRight: 15,
  },
  chanelList: {
    listStyleType: 'none',
    padding: 0,
    margin: 0,
  },
  chanel: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '13px 15px 13px 32px',
  },
  chanelInfo: {
    listStyleType: 'none',
    padding: 0,
    marginLeft: 8,
    marginRight: 65,
    flex: 1,
  },
  chanelTitle: {
    fontFamily: 'Roboto',
    fontSize: 14,
    color: 'rgba(0, 0, 0, 0.75)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    lineHeight: 1.6,
    color: 'rgba(0, 0, 0, 0.5)',
  },
  chanelStatusIcon: {
    width: 16,
    height: 16,
    minWidth: '16px',
  },

  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing.unit * 3,
    paddingBottom: theme.spacing.unit * 3,
    paddingLeft: theme.spacing.unit * 2,
    paddingRight: theme.spacing.unit * 2,
    [theme.breakpoints.up('md')]: {},
    '@media (min-width:960px)': {
      // eslint-disable-line no-useless-computed-key
      paddingLeft: theme.spacing.unit * 8,
      paddingRight: theme.spacing.unit * 8,
    },
  },
  link: {
    textDecoration: 'none',
  },
  toolbarInner: {
    padding: 0,
  },
  extendedIcon: {
    marginRight: 5,
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginLeft: 32,
    background: '#fff',
    borderRadius: 32,
  },
  info: {
    margin: 0,
    padding: 0,
    flex: 1,
  },
  siteIcon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 24,
    height: 24,
    margin: '0 19px 0 23px',
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: '100%',
    backgroundColor: 'rgb(44, 50, 157)',
  },
  list: {
    margin: '0 0 16px 0',
    padding: '7px 20px 10px 40px',
    listStyleType: 'none',
    borderRadius: 4,
  },
  user: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0)',
  },
  avatar: { width: 22, height: 22, marginRight: 10 },
  item: {
    position: 'relative',
    fontFamily: 'Roboto',
    fontSize: 12,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .75)',
    '&::before': {
      content: '"↳"',
      marginRight: 5,
    },
  },
  dataIcon: {
    width: 16,
    height: 16,
    fill: 'rgba(0, 0, 0, .5)',
  },
  gaSymbol: {
    width: 36,
    height: 36,
  },
  chanelError: {
    backgroundColor: 'rgba(255, 59, 48, 0.1)',
  },
  chanelStatus: {
    fontFamily: 'Roboto',
    fontSize: 10,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.2,
    letterSpacing: 'normal',
    color: 'rgb(0, 0, 0, .5)',
  },
  chanelStatusError: {
    color: 'rgb(255, 59, 48)',
  },
  '@keyframes greyPulse': {
    '0%': {
      backgroundColor: 'grey',
    },
    '50%': {
      backgroundColor: '#BBB',
    },
    '100%': {
      backgroundColor: 'grey',
    },
  },
  '@keyframes trianglePulse': {
    '0%': {
      borderColor: 'grey transparent transparent transparent',
    },
    '50%': {
      borderColor: '#BBB transparent transparent transparent',
    },
    '100%': {
      borderColor: 'grey transparent transparent transparent',
    },
  },
  tooltip: {
    position: 'absolute',
    whiteSpace: 'pre-line',
    backgroundColor: '#000',
    color: '#fff',
    borderRadius: 4,
    fontSize: 14,
    padding: '5px 8px',
    top: -22,
    left: 24,
    zIndex: 10,
    animationName: 'greyPulse',
    animationIterationCount: 'infinite',
    animationDuration: '1.4s',
    '&::after': {
      content: '" "',
      position: 'absolute',
      bottom: 0,
      left: 31,
      width: 0,
      height: 0,
      borderStyle: 'solid',
      borderWidth: '7px 5px 0 5px',
      borderColor: '#000000 transparent transparent transparent',
      transform: 'translateY(100%)',
      animationName: 'trianglePulse',
      animationIterationCount: 'infinite',
      animationDuration: '1.4s',
    },
  },

  crmList: {
    paddingTop: '20px',
  },
  crmWrapper: {
    paddingTop: '10px',
  },
  crmBlock: {
    marginTop: '16px',
    width: '350px',
    borderRadius: '16px',
    boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#ffffff',
    padding: '16px 14px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '14px',
  },
  existedCrmBlock: {
    marginTop: '16px',
    width: '350px',
    borderRadius: '16px',
    boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#ffffff',
    padding: '16px 14px',
  },
  crmButton: {
    width: '126px',
    height: '32px',
    lineHeight: '32px',
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'center',
    borderRadius: '4px',
    backgroundColor: '#ffcc00',
    outline: 'none',
    textDecoration: 'none',
    color: '#000',
  },
  crmButtonNew: {
    width: '126px',
    height: '32px',
    lineHeight: '32px',
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'center',
    borderRadius: '4px',
    border: 'solid 1px #8866ff',
    backgroundColor: '#fff',
    outline: 'none',
    textDecoration: 'none',
    color: '#000',
  },
  newCrm: {
    width: '188px',
  },
  crmStatisticBlock: {
    marginTop: '10px',
  },
  crmStatisticWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginTop: '10px',
  },
  crmDescription: {
    opacity: '0.75',
    fontSize: '12px',
  },
  crmsWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  statisticData: {
    opacity: '0.5',
    fontFamily: 'Roboto',
    fontSize: '10px',
    wordBreak: 'break-all',
  },
  statisticTitle: {
    opacity: '0.75',
    fontFamily: 'Roboto',
    fontSize: '14px',
  },
  errors: {
    color: '#ff3b30',
    fontFamily: 'Roboto',
    fontSize: '10px',
  },

  action: {
    fontSize: 14,
    fontWeight: 500,
    color: 'rgb(0, 0, 0)',
    whiteSpace: 'pre-line',
  },
  icon: {
    marginRight: 16,
  },
  description: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    padding: 16,
    cursor: 'pointer',
  },

  appBar: {
    position: 'relative',
  },
  paper: { backgroundColor: '#ffcc00' },
  modalTitle: {
    marginBottom: 24,
    textAlign: 'center',
  },
  modalIcon: {
    marginBottom: 16,
  },
  subTitle: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 'normal',
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'center',
    color: 'rgb(0, 0, 0)',
    textAlign: 'center',
    whiteSpace: 'pre-line',
  },
})

class Chat extends Component {
  constructor(props) {
    super(props)
    this.state = {
      site: window.state.site,
      openModal: false,
      openSnakbar: false,
      fetching: {
        bitrix24: false,
        bitrix: false,
        retail: false,
      },
      crmApplications: state.crmApplications,
      isEditedStatistics: window.state.hasEditedStatistics,
      isActiveDataSources: window.state.hasActiveDataSources,
      user: window.state.user,
    }
  }

  successData = status => {
    if (status === 'ok') {
      this.timer = setTimeout(
        () =>
          this.setState({
            openModal: false,
            isFetching: false,
            openSnakbar: true,
          }),
        600
      )
    }
  }

  handleClickOpen = event => {
    event.preventDefault()
    this.setState({ openModal: true })
  }

  handleClose = () => {
    this.setState({ openModal: false, isFetching: false })
  }

  handleCloseSnakbar = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    this.setState({ openSnakbar: false })
  }

  handleSubmit = values => {
    this.setState({
      isFetching: true,
    })

    const url = '/chat/create'

    const options = values => ({
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(values),
    })

    const errors = response => {
      if (response.errors) {
        const arrErrors = [].concat(
          ...Object.values(response.errors).map(error => error)
        )

        arrErrors &&
          arrErrors.map(error =>
            this.props.enqueueSnackbar(error, {
              variant: 'error',
              preventDuplicate: true,
              autoHideDuration: 6000,
            })
          )
      }

      this.setState({
        isFetching: false,
      })
    }

    function handleResponse(response) {
      return response.json().then(res => {
        if (response.status >= 200 && response.status < 300) {
          return res
        } else {
          throw res
        }
      })
    }

    fetch(url, options(values))
      .then(handleResponse)
      .then(({ status }) => {
        this.successData(status)
      })
      .catch(errors)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
  }

  handleNewCrm(e, crm) {
    crm = crm || ''

    let fetching = this.state.fetching
    fetching[crm] = true
    this.setState({ fetching: fetching })

    let data = {
      crm_name: crm,
      description: '',
    }

    const url = '/chat/create'

    const json = response => {
      return response.json()
    }

    const status = response => {
      if (response.status >= 200 && response.status < 300) {
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.statusText))
      }
    }

    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute('content'),
      },
      body: JSON.stringify(data),
    })
      .then(status)
      .then(json)
      .then(data => {
        let crmApplications = this.state.crmApplications
        crmApplications[crm] = true

        let fetching = this.state.fetching
        fetching[crm] = true

        this.setState({
          fetching: fetching,
          crmApplications: crmApplications,
        })
      })
      .catch(function(error) {
        console.log('Request failed', error)
      })

    e.preventDefault()
  }

  render() {
    const { classes } = this.props
    const { openModal, openSnakbar, site, user } = this.state

    return (
      <Fragment>
        {user.wizard_finished_at && (
          <LicenseExpired>
            <ActionsForUsing />
          </LicenseExpired>
        )}
        <div className={classes.pageTemplate}>
          <AppBar
            position="static"
            color="inherit"
            elevation={0}
            style={{ padding: '24px' }}
          >
            <Toolbar className={classes.toolbarInner}>
              <LogoData />

              <a className={classes.container} href={`http://${site.url.replace(/(http|https):\/\//is, '')}`} target="_blank">
                <div className={classes.siteIcon}>S</div>
                <ul className={classes.info}>
                  <Typography component="li" variant="body1">
                    {site.url}
                  </Typography>
                  <Typography component="li" variant="overline">
                    {site.name}
                  </Typography>
                </ul>
              </a>

              {user.wizard_finished_at && <TraficLight />}
            </Toolbar>
          </AppBar>

          <CustomizeAll />

          <div className={classes.wizardRow}>
            <LeftNavigationDashboard />

            <div className={classes.wizardContent}>
              <p>
                Экспорт данных о заявках (статус "Входящая заявка") из
                онлайн-чата в Google Analytics
              </p>
              <div className={classes.crmsList}>
                <div className={classes.crmList}>
                  <div className={classes.crmBlock}>
                    <div className={classes.newCrm}>
                      <b>В списке нет вашего чата?</b>
                      <br />
                      Оставьте заявку.
                    </div>
                    <a
                      href="#"
                      className={classes.crmButtonNew}
                      onClick={this.handleClickOpen}
                    >
                      Заявка
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <Dialog
              fullScreen
              open={openModal}
              onClose={this.handleClose}
              TransitionComponent={Transition}
              PaperProps={{
                classes: {
                  root: this.props.classes.paper,
                },
              }}
            >
              <AppBar className={this.props.classes.appBar} elevation={0}>
                <Toolbar style={{ paddingTop: 16 }}>
                  {/* <LogoHelpData /> */}
                  <IconButton
                    color="inherit"
                    onClick={this.handleClose}
                    aria-label="Close"
                    style={{ marginLeft: 'auto' }}
                  >
                    <CloseIcon style={{ fill: '#fff' }} />
                  </IconButton>
                </Toolbar>
              </AppBar>
              <div
                style={{
                  maxWidth: 400,
                  width: '100%',
                  margin: '0 auto',
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'column',
                }}
              >
                <header className={classes.modalTitle}>
                  {/* <DishIcon width={48} height={32} className={classes.modalIcon} /> */}
                  <h6
                    style={{
                      fontFamily: 'Roboto',
                      fontSize: 24,
                      fontWeight: 'bold',
                      fontStyle: 'normal',
                      fontStretch: 'normal',
                      lineHeight: 'normal',
                      letterSpacing: 'normal',
                      textAlign: 'center',
                      color: 'rgb(0, 0, 0)',
                      margin: '0 0 24px 0',
                    }}
                  >
                    Напишите нам!
                  </h6>
                  <div className={classes.subTitle}>
                    {`Какой чат вы используете?`}
                  </div>
                </header>
                <Wrapper
                  shadow={1}
                  style={{
                    width: '100%',
                    borderRadius: 8,
                    overflow: 'hidden',
                    padding: '40px 50px 50px 50px',
                    backgroundColor: 'rgb(255, 255, 255)',
                    fontFamily: '"Exo 2", "Helvetica", "Arial", sans-serif',
                    lineHeight: 1.5,
                  }}
                >
                  <ChatApplicationForm
                    onSubmit={this.handleSubmit}
                    isFetching={this.state.isFetching}
                    // initialValues={{ email: user.email, phone: user.phone }}
                  />
                </Wrapper>
              </div>
            </Dialog>

            <Snackbar
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              open={openSnakbar}
              autoHideDuration={5000}
              onClose={this.handleCloseSnakbar}
              ContentProps={{
                'aria-describedby': 'message-id',
              }}
              message={<span id="message-id">Заявка отправлена!</span>}
              action={[
                <IconButton
                  key="close"
                  aria-label="Close"
                  color="inherit"
                  className={classes.close}
                  onClick={this.handleCloseSnakbar}
                >
                  <CloseIcon />
                </IconButton>,
              ]}
            />
          </div>
        </div>
      </Fragment>
    )
  }
}

export default withStyles(styles)(Chat)
